import React, { useState } from 'react';
import cn from 'classnames';
import { ContentState } from 'draft-js';

import AttachmentPreviewModal from 'Shared/components/AttachmentPreviewModal/AttachmentPreviewModal';
import AttachmentSmartMenu from 'Shared/components/AttachmentSmartMenu/AttachmentSmartMenu';
import { isImageFromContentType } from 'Shared/helpers';

import './ImageAttachment.scss';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  entityKey: string;
  imageAttachmentFullWidth: string;
  children: React.ReactNode;
  contentState: ContentState;
  onImageAttachmentRemove: Function;
};

const ImageAttachment = ({
  entityKey,
  contentState,
  onImageAttachmentRemove,
  imageAttachmentFullWidth,
  children,
}: Props) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const { src, fileName, fileType, attachmentId } = contentState.getEntity(entityKey).getData();

  const isImage = isImageFromContentType(fileType);

  const handleAttachmentClick = () => setIsPreviewOpen(!isPreviewOpen);
  const handleRemoveClick = () => onImageAttachmentRemove(attachmentId);
  let srcRelative;
  try {
    srcRelative = src?.startsWith('http') ? new URL(src).pathname : src;
  } catch {
    srcRelative = src;
  }
  return (
    <>
      {isPreviewOpen && (
        <AttachmentPreviewModal
          isOpen={isPreviewOpen}
          onToggle={handleAttachmentClick}
          attachment={{ fileName, url: srcRelative, contentType: fileType, isImage }}
        />
      )}
      <div className={cn('image-attachment', { 'w-100': imageAttachmentFullWidth })} contentEditable={false}>
        <div
          className={cn('image-attachment-filename d-flex  flex-column', {
            'w-100': imageAttachmentFullWidth,
          })}
          onClick={handleAttachmentClick}
        >
          <div
            className={cn('image-attachment-document d-flex align-items-center', {
              'image-attachment-document--padding': attachmentId,
            })}
          >
            <span className="mx-1">
              <WpIcon name="paperclip" />
            </span>
            <b>{fileName}</b>
          </div>
          {isImage && (
            <div className="image-attachment-preview pl-2 pt-1" onClick={handleAttachmentClick}>
              <img
                src={srcRelative}
                alt={fileName}
                className={cn('image-attachment-image', {
                  'image-attachment-image-minified': !imageAttachmentFullWidth,
                })}
              />
            </div>
          )}
        </div>
        {attachmentId && (
          <AttachmentSmartMenu
            attachment={{ id: attachmentId, fileName, url: srcRelative, isImage }}
            onRemoveClick={handleRemoveClick}
          />
        )}
        {children}
      </div>
    </>
  );
};

export default ImageAttachment;
